import {View} from './view';
import { Translations } from '../config/translations';

export class QuantityView extends View {

    id = '';
    quantityContainer: HTMLElement = document.createElement('div');

    renderQuantityForm(setQuantity: any, id: string, productName: any, isAddon?: boolean) {
        this.id = id;
        this.quantityContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-quantity');
        this.quantityContainer.innerHTML = `<fieldset id="df_${id}_quantity_container" class='form-columns-2 df-quantity-area df-fieldset'>
            <div class='field hs-form-field df-field'>
               <label>
                    <p id="df-${this.id}" name="${productName}" class='df-quanity-product df-f-product-label'  style="font-size: 16px">${productName}</p>
                    <span class='df-f-label' style="font-size: 16px" data-label="quantity">${Translations.QUANTITY}</span>
               </label>
               <div class='input'>
                    <input type='number' id='df_${id}_quantity' name='df_quantity' class='hs-input df-input'
                        autocomplete='off' step='1' min='1' value='1' onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    />
               </div>
             </div>
            </fieldset>
            <fieldset class='form-columns-1 df-fieldset'>
                <label class='error df-f-label' id='${id}-quantity-error'></label>
            </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(this.quantityContainer);
        const quantityInput = this.getQuantityInputElement();
        quantityInput.oninput = () => {
            const input = document.querySelector(`#df_${id}_quantity`) as HTMLInputElement;
            const value = input.value;
            const quantity = +value;
            setQuantity(quantity, id, isAddon);
        };
    }

    setProductName(name: any) {
        const nameField = this.getHtmlElement(`#df-${this.id}`);
        nameField.setAttribute('name', name);
        nameField.innerText = name;
    }

    showError() {
        const quantityErrorElement = this.getQuantityErrorElement();
        quantityErrorElement.innerHTML = Translations.QUANTITY_INVALID;
    }

    hideError() {
        const quantityErrorElement = this.getQuantityErrorElement();
        quantityErrorElement.innerHTML = '';
    }

    getQuantityInputElement = () => {
        return this.getHtmlElement(`#df_${this.id}_quantity`);
    }

    getQuantityErrorElement = () => {
        return this.getHtmlElement(`#${this.id}-quantity-error`);
    }

    resetQuantity(){
        const quantityInput = this.getQuantityInputElement() as HTMLInputElement;
        quantityInput.value = '1';
    }

    showForm() {
        this.quantityContainer.style.display = 'inherit';
    }

    hideForm() {
        this.quantityContainer.style.display = 'none';
    }

}
